module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"show_more":"Показать ещё"},"en":{"show_more":"Show more"}}')
  delete Component.options._Ctor
}
